import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    defaultPlaceholderMobile: string;
    defaultPlaceholderDesktop: string;
    searchFor: string;
    placeholderText: {
        /** Example placeholder for footage search */
        footage: string;
        /** Example placeholder for comments search */
        comments: string;
        /** Example placeholder for transcript search */
        transcript: string;
        /** Example placeholder for uploads search with user name */
        uploads: ({ name }: {
            name: string;
        }) => string | React.ReactNode;
    };
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Default placeholder text for mobile devices */
            defaultPlaceholderMobile: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "usePlaceholderText.defaultPlaceholderMobile?c=2kd2rmwbh0td9", defaultMessage: "Search for status, assignee, and more" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Default placeholder text for desktop devices */
            defaultPlaceholderDesktop: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "usePlaceholderText.defaultPlaceholderDesktop?c=3tnoz7njjbvmz", defaultMessage: "Search for status, assignee, keywords, and more" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Prefix text for search placeholder */
            searchFor: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "usePlaceholderText.searchFor?c=189bq3qlzhsnd", defaultMessage: "Search for" }));
                },
                enumerable: true,
                configurable: true
            },
            placeholderText: {
                get() {
                    return Object.defineProperties({
                        [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                    }, {
                        /** Example placeholder for footage search */
                        footage: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "usePlaceholderText.placeholderText.footage?c=1w4wk0toe0l6e", defaultMessage: "footage of cloudy skies" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Example placeholder for comments search */
                        comments: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "usePlaceholderText.placeholderText.comments?c=1q5g1i1wb4bj4", defaultMessage: "comments with \"looks rough\"" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Example placeholder for transcript search */
                        transcript: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "usePlaceholderText.placeholderText.transcript?c=3l7lgc54t2mig", defaultMessage: "transcript containing African elephants" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Example placeholder for uploads search with user name */
                        uploads: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => ({ name }: {
                                    name: string;
                                }) => __intl__.intl().formatMessage({ id: "usePlaceholderText.placeholderText.uploads?c=urcj628w8qaj", defaultMessage: "uploads by {name}" }, { name: name }));
                            },
                            enumerable: true,
                            configurable: true
                        }
                    });
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
